export default {
    "Latest Material": [
        {
            title: "DET Study 100-Page Guide (EN)",
            link: "https://firebasestorage.googleapis.com/v0/b/detstudy-84d58.appspot.com/o/002-R03-A.pdf?alt=media&token=459ced49-4489-48ad-ba27-559f9de1a3dc",
            required_permission: true,
            download: true
        }
    ],

}